import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import Layout from "components/sales/layout/layout";
import TeamType from "components/sales/formSection/teamType/teamType";
import OperationTeam from "components/sales/formSection/operationTeam/operationTeam";
import OtherInfo from "components/sales/formSection/otherInfo/otherInfo";
import { Button } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ComercialType from "components/sales/formSection/commTypePostB2b/comercialType";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const PostB2bAlliance = ({
  dropDownData,
  getDropDownData,
  submitB2bData,
  match,
  history,
  documentUploadUrl,
  documentUrlData,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);

  const allianceInput = {
    other: null,
    supply: null,
    product: null,
    operation: null,
    commercial: null,
  };
  const [leadId, setleadId] = useState();
  const [allianceData, setAllianceData] = useState(allianceInput);
  const [isModal, setIsModal] = useState(false);
  useEffect(() => {
    setleadId(match.params.leadId);
  }, []);

  const handleOther = (val) => {
    setAllianceData({ ...allianceData, other: val });
  };
  const handleSupply = (val) => {
    setAllianceData({ ...allianceData, supply: val });
  };
  const handleProduct = (val) => {
    setAllianceData({ ...allianceData, product: val });
  };
  const handleOperation = (val) => {
    setAllianceData({ ...allianceData, operation: val });
  };
  const handleCommercial = (val) => {
    setAllianceData({ ...allianceData, commercial: val });
  };

  const handleSubmit = () => {
    const { product, operation, supply, commercial, other } = allianceData;
    const submitData = {
      ...product,
      ...other,
      ...supply,
      ...commercial,
      ...operation,
    };
    if (other === null || commercial === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      setIsModal(true);
      submitB2bData(submitData);
    }
  };
  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };

  useEffect(() => {
    if (match) setleadId(match.params.id);
    if (leadId) getDropDownData(leadId);
  }, [leadId]);

  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

  return (
    <Layout
      title={localization.postSalesB2b}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
    >
      <TeamType
        label={localization.supplyTeam}
        partnerDate={localization.partnerDate}
        deliveryDate={localization.supplyDeliveryDate}
        poc={localization.supplyPoc}
        escalationContact={localization.escalContact}
        costPerSlot={localization.costPerSlot}
        supply="true"
        handleValue={handleSupply}
      />
      <OperationTeam handleValue={handleOperation} />
      <TeamType
        label={localization.productTeam}
        partnerDate={localization.partnerDate}
        deliveryDate={localization.productDate}
        poc={localization.productPoc}
        escalationContact={localization.escalContact}
        supply="false"
        handleValue={handleProduct}
      />
      <ComercialType
        dropDownData={dropDownData}
        getDropDownData={getDropDownData}
        handleValue={handleCommercial}
      />
      <OtherInfo
        dropDownData={dropDownData}
        getDropDownData={getDropDownData}
        handleValue={handleOther}
        leadId={leadId}
        match={match}
        documentUploadUrl={documentUploadUrl}
        documentUrlData={documentUrlData}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/postSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSalesB2bList}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

PostB2bAlliance.propTypes = {
  dropDownData: PropTypes.any,
  getDropDownData: PropTypes.any,
  submitB2bData: PropTypes.any,
  match: PropTypes.any,
  history: PropTypes.any,
};

export default PostB2bAlliance;
